import type { FC } from 'react';

import type { LinePattern } from '@ipfabric/utils';
import { type OptionProps, components } from 'react-select';

interface OptionType {
  value: LinePattern;
  label: string;
}

export const StrokeOption: FC<OptionProps<OptionType>> = (props) => (
  <components.Option {...props}>
    <div className='flex flex-row items-center'>
      <span
        className='graph-layout-settings-protocol-options__stroke mr-lgu-3'
        style={{ borderBottomStyle: props.data.value }}
      />
      <span className='w-lgu-20 whitespace-nowrap'>{props.data.label}</span>
    </div>
  </components.Option>
);
